<template>
    <div>
        <b-avatar id="popover-target-1"
                  badge-variant="danger"
                  badge-top
                  size="lg"
                  class="avatar-float"
                  button
                  icon="bi-info-lg"
                  variant="info"
                  v-show="!noSuggestion">
            <i class="fa-regular fa-lightbulb" style="scale: 1.2"></i>
        </b-avatar>

        <b-popover target="popover-target-1" triggers="focus" placement="top" boundary="window" delay="300"
                   @show="getLastQueryPackage()">
            <template #title>
                <div class="d-flex flex-row">
                    <div style="height: min-content" class="mt-auto mb-auto">您可能想要搜索</div>
                    <overlay-pop v-if="hasLast"
                                 class="ml-auto"
                                 btn-variant="info"
                                 title="最近一次查询"
                                 @btnClick="loadQueryPackage">
                        <div class="d-flex flex-column">
                            <template v-for="(item,i) of lastQueryPackage">
                                <b-button variant="light" class="mb-1 value-style" :key="i"
                                          @click="emitFilter(item.key, item.value)">
                                    {{ item.keyLabel }}:{{ item.label || item.value }}
                                </b-button>
                            </template>
                        </div>
                    </overlay-pop>
                </div>
            </template>
            <div class="d-flex flex-column window-style">
                <template v-for="(item,index) of suggestions">
                    <div :key="index" class="mb-1">
                        <h5><span class="text-info">{{ item.label }}</span></h5>
                        <div class="d-flex flex-wrap">
                            <div v-for="(value,vi) of item.values" :key="vi">
                                <b-button :variant="value.used?'outline-info':'light'" class="ml-1 mb-1 value-style"
                                          @click="emitFilter(item.key, value.value)">
                                    {{ value.label || value.value }}
                                </b-button>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </b-popover>
    </div>
</template>

<script>
import {_tryTranslateValueLabel} from "@/utils/em-model-value-translate";
import OverlayPop from "@/components/workflow/stuffs/OverlayPop.vue";

export default {
    name: "FilterSuggestion",
    components: {OverlayPop},
    props: {
        tag: String,
        fieldList: Array,
        noAutoShow: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            suggestions: null,
            response: null,
            needWaitEntityQuery: false,
            tryCount: 0,
            noSuggestion: false,

            hasLast: false,
            lastQueryPackage: null,
            lastQueryLoading: false
        }
    },
    computed: {
        fieldMap() {
            let fieldMap = {};
            for (let item of this.fieldList) {
                fieldMap[item.key] = item;
            }
            return fieldMap;
        },
        tableRowsCount() {
            return this.$parent.$_emCustomVuexMixin_voStore;
        },
    },
    watch: {
        fieldList() {
            this.reLoad();
        },
        needWaitEntityQuery() {
            if (this.needWaitEntityQuery) {
                this.needWaitEntityQuery = false;
                this.tryCount++;
                if (this.tryCount > 4) {
                    return;
                }
                setTimeout(() => this.reLoad(), 500);
            }
        },
        tableRowsCount() {
            if (this.tableRowsCount.length > 0) {
                this.focusTheAvatar(false);
            }
        },
    },
    mounted() {
        this.getSuggestion();
        this.getLastQueryPackage();
    },
    methods: {
        getSuggestion(tag = this.tag) {
            if (tag && this.fieldList && this.fieldList.length > 0) {
                this.$store.dispatch('api/get', {
                    url: process.env.VUE_APP_EM_ADMIN_URL + "/analytics/log/querySuggestion/paramValue?tag=" + encodeURIComponent(tag),
                    commonErrorHandle: false
                }).then(response => {
                    this.response = response;
                    this.$nextTick(() => this.reLoad());
                });
            } else {
                this.noSuggestion = true;
            }
        },
        reLoad() {
            this.loadSuggestion(this.response);
            if (this.suggestions && this.suggestions.length > 0) {
                if (!this.noAutoShow) {
                    this.focusTheAvatar();
                }
                this.noSuggestion = false;
            } else {
                this.noSuggestion = true;
            }
        },
        focusTheAvatar(focus = true) {
            if (focus) {
                document.getElementById('popover-target-1').focus();
            } else {
                document.getElementById('popover-target-1').blur();
            }
        },
        loadSuggestion: function (response) {
            if (!(response && response.params.length > 0)) {
                return;
            }
            let tempList = [];
            for (let param of response.params) {
                let pk = param.name + "Filter";
                if (this.fieldMap.hasOwnProperty(pk)) {
                    let field = this.fieldMap[pk];
                    let values = param.values;
                    if (values && values.length > 0) {
                        let valueList = [];
                        for (let value of values) {
                            let tItem = _tryTranslateValueLabel(field, value.value);
                            if (tItem.needWaitEntityQuery) {
                                this.needWaitEntityQuery = true;
                            }
                            valueList.push(tItem);
                        }
                        let temp = {
                            key: pk,
                            label: this.$t(field.label),
                            values: valueList,
                        };
                        tempList.push(temp);
                    }
                }
            }
            this.suggestions = tempList;
        },
        getLastQueryPackage(tag = this.tag) {
            if (this.lastQueryLoading) {
                return;
            }
            if (tag && this.fieldList && this.fieldList.length > 0) {
                this.lastQueryLoading = true;
                this.$store.dispatch('api/get', {
                    url: process.env.VUE_APP_EM_ADMIN_URL + "/analytics/log/querySuggestion/recentParams/last?tag=" + encodeURIComponent(tag),
                    commonErrorHandle: false
                }).then(response => {
                    this.hasLast = response && Object.keys(response).length > 0;
                    if (this.hasLast) {
                        let tempList = [];
                        for (let k of Object.keys(response)) {
                            let pk = k + 'Filter';
                            let value = response[k];
                            if (this.fieldMap.hasOwnProperty(pk)) {
                                let field = this.fieldMap[pk];
                                let temp = _tryTranslateValueLabel(field, value);
                                temp.key = pk;
                                temp.keyLabel = this.$t(field.label)
                                tempList.push(temp);
                            }
                        }
                        this.lastQueryPackage = tempList;
                    } else {
                        this.lastQueryPackage = null;
                    }
                    this.$forceUpdate();
                    if (!this.noAutoShow) {
                        this.focusTheAvatar();
                    }
                }).finally(() => this.lastQueryLoading = false);
            }
        },
        loadQueryPackage() {
            this.$interaction({
                identifyModule: 'filter-suggestion',
                identifyCode: 'filter-suggestion-history-click',
                actionName: '#last'
            })
            for (let item of this.lastQueryPackage) {
                this.$emit('setFilter', {
                    key: item.key,
                    value: item.value
                });
            }
            this.$parent.doQuery();
        },
        //-----
        emitFilter(key, value) {
            this.$interaction({
                identifyModule: 'filter-suggestion',
                identifyCode: 'filter-suggestion-click',
                actionName: key,
                actionContent: (value instanceof Array) ? JSON.stringify(value) : value
            })
            this.$emit('setFilter', {key, value})
        },
    }
}
</script>

<style scoped>
.avatar-float {
    position: fixed;
    bottom: 1rem;
    z-index: 10000;
    transition: all .3s ease-in-out;

    right: 0;
    width: 1.2rem !important;
    border-radius: .5rem 0 0 .5rem !important;
}

.avatar-float:focus {
    right: 2rem;
    width: 3.5rem !important;
    border-radius: 50% !important;
}

.window-style {
    max-width: 400px;
    max-height: 600px;
    overflow: auto;
}

.value-style {
    padding: .1rem .2rem !important;
}
</style>
